import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import HeaderFour from '../header/HeaderFour';
import BreadcrumbBlog from '../inner/breadcrumb/BreadcrumbBlog';
import Footer from '../elements/Footer';
import RecentBlog from './RecentBlog';
import Help from './Help';
import HeaderNew from '../header/HeaderNew';

function BlogDetails() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    const [blog, setBlog] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (id) {
            axios.get(`https://solanthegroup.com/admin/api/blogs/${id}`)
                .then(response => {
                    setBlog(response.data[0]);
                    setError(false);
                })
                .catch(error => {
                    console.error("Error fetching blog details:", error);
                    setError(true);
                });
        }
    }, [id]);

    if (error) {
        return <div className="error-message">Error loading blog details.</div>;
    }

    if (!blog) {
        return <div className="loading"></div>;
    }

    return (
        <div className='service-details'>
            <HeaderNew/>
            <main>
                {/* <div className="breadcrumb-area bg_image tmp-section-gap"

                    style={{ backgroundImage: `url(assets/images/breadcrumb/blog.webp)` }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-inner text-center">
                                    <h1 className="title split-collab">Latest Blog</h1>
                                    <ul className="page-list">
                                        <li className="tmp-breadcrumb-item">
                                            <a href="/">Home</a>
                                        </li>
                                        <li className="icon">
                                            <i className="fa-solid fa-angle-right" />
                                        </li>
                                        <li className="tmp-breadcrumb-item active">
                                            Blog Details</li>
                                    </ul>
                                    <div className="circle-1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="tmp-service-section tmp-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="blog-details-left-area border-bottom">
                                    <div className="thumbnail-top">
                                        <img src={`https://solanthegroup.com/admin/${blog.banner}`} alt={blog.title} />
                                    </div>
                                    <div className="blog-details-discription">
                                        <h3 className="title split-collab">{blog.title}</h3>
                                        <div className="disc" dangerouslySetInnerHTML={{ __html: blog.description }}></div>
                                    </div>
                                </div>
                                <div className="blog-details-bottom-area mt--40">
                                    <div className="tag-socila-area-blgo-details">
                                        <div className="social-blog-tag-area">
                                            <span>Share:</span>
                                            <ul>
                                                <li><a href={blog.facebook}><i className="fa-brands fa-facebook-f" /></a></li>
                                                <li><a href={blog.twitter}><i className="fa-brands fa-twitter" /></a></li>
                                                <li><a href={blog.instagram}><i className="fa-brands fa-instagram" /></a></li>
                                                <li><a href={blog.pinterest}><i className="fa-brands fa-pinterest-p" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 pl--50 pl_md--10 pl_sm--10 mt_md--50 mt_sm--50">
                                <div className="side-bar-details-page">
                                    <RecentBlog />
                                    <Help />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
        </div>
    );
}

export default BlogDetails;
